import React from "react";
import "../style/portfolio.css";
import MovieApp from "./Portfolios/MovieApp";
import Restaurant from "./Portfolios/Restaurant";
import Invoice from "./Portfolios/Invoice";
// import Weather from "./Portfolios/Weather";
import Crm from "./Portfolios/Crm";
import TodoApp from "./Portfolios/TodoApp";
import Feedback from "./Portfolios/Feedback";
import CaseStudy from "./Portfolios/CaseStudy";

const Portfolios = () => {
  return (
    <div id="portfolio" className="portfolio-container">
      <h1 className="headings">Portfolio</h1>
      <MovieApp />
      <Restaurant />
      <Invoice />
      {/* <Weather /> */}
      <Feedback />
      <TodoApp />
      <Crm />
      <CaseStudy />
    </div>
  );
};

export default Portfolios;
